export default {
  areaID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  regionServiceID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null
  },
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  cpf: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  email: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  cellPhone: {
    value: '',
    maxlength: '20',
    required: true,
    state: null
  },
  stateID: {
    value: null,
    options: [],
    clearOption: false,
    required: true,
    state: null
  },
  cityID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null
  },
  budgetSystemList: {
    value: null,
    options: [
      { label: 'AUDATEX', value: '93c9619a-4431-49d2-baa5-039eddec8e69' },
      { label: 'ORION', value: '3be6ab81-c715-4ea3-b5a4-13bad87ae6f3' },
      { label: 'SOMA', value: 'af9a2993-db6a-41a0-8830-1dadf13bc91d' },
      { label: 'CILIA', value: '11e79836-d3c0-470d-ba6b-0acd2c600c49' },
      { label: 'K2TEC', value: '47951a71-96d6-4b06-bea5-bf30cb5a04c1' }
    ],
    required: true,
    state: null
  },
  regulationTypeList: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  schedulingTypeList: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  insuranceList: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  businessTypeList: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  bankID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  agency: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  accountBank: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  },
  additionalExpenses: {
    value: '',
    options: [],
    required: true,
    state: null
  },
  includeKM: {
    value: '',
    options: [],
    required: true,
    state: null
  },
  pix: {
    value: '',
    maxlength: '200',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/expert/expert-form.js